<template>
    <div :class="wrapperClass">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            /**
             * ORientation of the group - vertical or horizontal
             */
            orientation: {
                type : String,
                default: 'horizontal',
            },
            /**
             * Tight froup has no margin between buttons
             */
            tight: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            wrapperClass() {
                let result = ['uk-flex', 'uk-button-group', 's-button-group'];

                if (this.orientation === 'vertical') {
                    result.push('uk-flex-column');
                    result.push('s-button-group--vertical');
                } else {
                    result.push('s-button-group--horizontal');
                }

                if (this.tight) {
                    result.push('s-button-group--tight');
                }

                return result;
            }
        }
    }
</script>
<style  lang="scss">
    .s-button-group {


        &--vertical {
            .uk-button {
                margin-block-end:  calc(var(--global-margin) * 0.3)!important;

                &:last-of-type {
                    margin-block-end: 0;
                }
            }

            &.uk-flex-wrap {
                .uk-button {
                    margin-block-end:  calc(var(--global-margin) * 0.3)!important;

                    &:last-of-type {
                        margin-block-end: 0;
                    }
                }
            }
        }



        &--horizontal {
            .uk-button {
                margin-inline-end:  calc(var(--global-margin) * 0.3)!important;

                &:last-of-type {
                    margin-inline-end: 0;
                }
            }

            &.uk-flex-wrap {
                .uk-button {
                    margin-block-end:  calc(var(--global-margin) * 0.3)!important;

                    &:last-of-type {
                        margin-block-end: 0;
                    }
                }
            }
        }

        &--vertical.s-button-group--tight {
            .uk-button {
                margin-block-end:  0px!important;

                &:last-of-type {
                    margin-block-end: 0px;
                }
            }

            &.uk-flex-wrap {
                .uk-button {
                    margin-block-end:  0px!important;

                    &:last-of-type {
                        margin-block-end: 0px;
                    }
                }
            }
        }

        &--horizontal.s-button-group--tight {
            .uk-button {
                margin-inline-end:  0px!important;

                &:last-of-type {
                    margin-inline-end: 0px;
                }
            }

            &.uk-flex-wrap {
                .uk-button {
                    margin-block-end:  0px!important;

                    &:last-of-type {
                        margin-block-end: 0px;
                    }
                }
            }
        }



    }
</style>
